export default __webpack_public_path__ + "static/media/img-older.74d1c0df.png";